import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const Footer = () => (
  <footer className="border-t mt-20">
    <div className="container mx-auto px-4 sm:px-6 py-12">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm">
        <div>
          <h4 className="font-display text-lg mb-3"> <img width={100} src="/images/ragazza20261.svg" alt="logo" /></h4>
          <p className="text-muted-foreground leading-relaxed">
            Elegance in Every Step
          </p>
        </div>
        <div>
          <h5 className="font-medium mb-3 tracking-wide uppercase text-xs">Información</h5>
          <ul className="space-y-2 text-muted-foreground">
            <Dialog>
              <DialogTrigger asChild>
                <button
                  type="button"
                  className="text-left transition-colors hover:text-foreground hover:underline underline-offset-4"
                >
                  Envios
                </button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-lg">
                <DialogHeader>
                  <DialogTitle>Envios</DialogTitle>
                </DialogHeader>
                <div className="space-y-3 text-sm text-muted-foreground">
                  <p>Entrega en 48 horas a partir del día en que se realiza la compra.
                    Los pedidos realizados el fin de semana serán enviados y entregados el día lunes.</p>

                </div>
              </DialogContent>
            </Dialog>
            <li>
              <Dialog>
                <DialogTrigger asChild>
                  <button
                    type="button"
                    className="text-left transition-colors hover:text-foreground hover:underline underline-offset-4"
                  >
                    Devoluciones
                  </button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-lg">
                  <DialogHeader>
                    <DialogTitle>Política de Cambios</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-3 text-sm text-muted-foreground">
                    <p>En Ragazza Shoes cuidamos cada detalle para ti.</p>
                    <ul className="list-disc pl-5 space-y-2">
                      <li>Se permite un (1) solo cambio por compra.</li>
                      <li>No realizamos devoluciones de dinero.</li>
                      <li>Los cambios pueden solicitarse hasta dentro de 10 días después de la compra.</li>
                      <li>
                        El producto debe encontrarse en perfecto estado, sin señales de uso y con su empaque
                        original.
                      </li>
                    </ul>
                    <p>Agradecemos tu comprensión y preferencia. 💖</p>
                  </div>
                </DialogContent>
              </Dialog>
            </li>
            {/* <li>Guía de tallas</li>
            <li>Contacto</li> */}
          </ul>
        </div>
        <div>
          <h5 className="font-medium mb-3 tracking-wide uppercase text-xs">Síguenos</h5>
          <ul className="space-y-2 text-muted-foreground">
            <li> <a href="https://www.instagram.com/ragazza__ec" target="_blank" rel="noopener noreferrer">
              Instagram
            </a></li>

            <li> <a href="https://api.whatsapp.com/send/?phone=593987038437&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a></li>
            <li> <a href="mailto:info@ragazza.com" target="_blank" rel="noopener noreferrer">
              ragazzashoes.ec@outlook.com
            </a></li>
            {/* <li>Pinterest</li> */}
          </ul>
        </div>
      </div>
      <div className="border-t mt-8 pt-6 text-xs text-muted-foreground">
        © 2026 RAGAZZA. Todos los derechos reservados.
      </div>
    </div>
  </footer>
);

export default Footer;
